<header class="app-legal-header">
  <div class="container">
    <div class="logo">
      <a routerLink="/">
        <img src="logo-text.svg" alt="GitCharger logo" />
      </a>
    </div>

    <button mat-icon-button class="navbar-toggle" (click)="toggleMobileNav()">
      <mat-icon>menu</mat-icon>
    </button>

    <div class="links" [@toggleMobileNav]="mobileNavState">
      <nav class="navbar" (click)="toggleMobileNav()">
        <a
          routerLink="/about"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          About
        </a>
        <a
          routerLink="/contact"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: true }"
        >
          Contact
        </a>
      </nav>

      <div class="right-buttons">
        <a routerLink="/" mat-stroked-button>Open GitCharger</a>
      </div>
    </div>
  </div>
</header>

<router-outlet></router-outlet>

<div class="app-legal-footer">

  <div class="footer-grid">

    <div class="footer-brand">
      <img class="footer-brand-logo" src="logo-footer.svg" alt="GitCharger logo" />
      <p class="footer-brand-tagline">EV charging, made for drivers. Built by drivers.</p>
      <div class="footer-brand-social">
        <a target="_blank" href="https://twitter.com/GitCharger" aria-label="Twitter">
          <img src="assets/social/twitter.svg" alt="" />
        </a>
        <a target="_blank" href="https://www.instagram.com/gitcharger" aria-label="Instagram">
          <img src="assets/social/instagram.svg" alt="" />
        </a>
        <a target="_blank" href="https://www.threads.com/@gitcharger" aria-label="Threads">
          <img src="assets/social/threads.svg" alt="" />
        </a>
        <a target="_blank" href="https://www.reddit.com/r/gitcharger" aria-label="Reddit">
          <img src="assets/social/reddit.svg" alt="" />
        </a>
        <a target="_blank" href="https://www.youtube.com/@GitCharger" aria-label="YouTube">
          <img src="assets/social/youtube.svg" alt="" />
        </a>
        <a target="_blank" href="https://www.tiktok.com/@gitcharger" aria-label="TikTok">
          <img src="assets/social/tiktok.svg" alt="" />
        </a>
      </div>
    </div>

    <div class="footer-col">
      <h4>Solutions</h4>
      <ul>
        <li><a routerLink="/contact" rel="noopener">For Operators
          <svg class="footer-ext" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M7 7h10v10"/></svg>
        </a></li>
        <li><a href="https://business.gitcharger.com" target="_blank" rel="noopener">For Advertisers
          <svg class="footer-ext" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M7 17 17 7M7 7h10v10"/></svg>
        </a></li>
        <li><a routerLink="/contact">For Developers <span class="footer-soon">Soon</span></a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4>Drivers</h4>
      <ul>
        <li><a routerLink="/">Map</a></li>
        <li><a routerLink="/about" fragment="trip-planner">Trip Planner</a></li>
        <li><a routerLink="/about" fragment="community-chat">Community Chat</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4>Company</h4>
      <ul>
        <li><a routerLink="/about">About</a></li>
        <li><a routerLink="/contact">Contact</a></li>
      </ul>
    </div>

    <div class="footer-col">
      <h4>Legal</h4>
      <ul>
        <li><a routerLink="/privacy">Privacy</a></li>
        <li><a routerLink="/terms">Terms</a></li>
      </ul>
    </div>

  </div>

  <div class="footer-bottom">
    <div class="copyright">
      <p>© {{ year }} GitCharger. All rights reserved.</p>
    </div>
  </div>
</div>
